/**
 * FreeDailyPro brand mark. A flat, single-color geometric "F" with a
 * small signal-dot accent -- deliberately simple so it reproduces
 * identically at any size (nav, favicon, footer, print). No gradients.
 * Replaces the earlier placeholder (a generic Lucide Sparkles icon in a
 * gradient square), which was never a designed mark.
 */
export function LogoMark({ className = "h-7 w-7" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 72 72"
      className={className}
      role="img"
      aria-label="FreeDailyPro"
    >
      <rect
        x="4"
        y="4"
        width="64"
        height="64"
        rx="15"
        fill="var(--color-card)"
        stroke="var(--color-border)"
        strokeWidth="1.5"
      />
      <rect x="22" y="20" width="7" height="32" fill="var(--color-primary)" />
      <rect x="22" y="20" width="21" height="7" fill="var(--color-primary)" />
      <rect x="22" y="33" width="16" height="7" fill="var(--color-primary)" />
      <circle cx="50" cy="48" r="4.5" fill="var(--color-primary)" />
    </svg>
  );
}
